module.exports = __webpack_public_path__ + "img/light.bf8a7191.svg";